export const removeBaseUrl = (pathname: string, baseUrl: string) =>
  (pathname = pathname.startsWith(baseUrl)
    ? pathname.slice(baseUrl.length)
    : pathname);
